import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { SettingsConfirmTemplate } from 'components/Templates'

const SettingsTemporaryCloseConfirm: FC = () => {
  return (
    <Layout title={'確認 | 臨時休業日の修正'}>
      <SettingsConfirmTemplate page={'close'} />
    </Layout>
  )
}

export default SettingsTemporaryCloseConfirm
